import type {
  AuthBasicUser,
} from '@robovision/rvai-auth'


interface BasicMemberParams {
  email: string
  firstName: string
  id: string
  lastName: string
}

export class BasicMember {
  static readonly modelName = 'BasicMember'

  public readonly email: string
  public readonly firstName: string
  public readonly id: string
  public readonly lastName: string

  public constructor (params: BasicMemberParams) {
    this.email = params.email
    this.id = params.id
    this.firstName = params.firstName
    this.lastName = params.lastName
  }

  public static fromResponse (data: AuthBasicUser): BasicMember {
    return new BasicMember({
      email: data.email,
      firstName: data.firstName,
      id: data.id,
      lastName: data.lastName,
    })
  }
}
